import { IBreadcrumb } from 'common/interfaces/common';
import { Routes } from 'constants/route.constants';
import { BreadcrumbId } from 'common/enums/html.enums';
import commonMessages from 'common/messages/messages';
import bookingMessages from 'modules/booking/messages';
import remittanceMessages from 'modules/remittance/messages';
import dictionaryMessages from 'modules/dictionaries/messages/messages';
import crmMessages from 'modules/crm/messages/common';
import ptMessages from 'modules/personal-training-crm/messages/messages';
import timeclockMessages from 'modules/timeclock/messages';
import daySheetMessages from 'modules/day-sheet/messages/common';
import reportMessages from 'modules/reports/messages/messages';
import serviceMessages from 'modules/services/messages/messages';
import posSettingsMessages from 'modules/pos-settings/messages/messages';
import permissionMessages from 'modules/permissions/messages/messages';
import communicationMessages from 'modules/communication/messages';
import clubSettingsMessages from 'modules/club-settings/messages';
import corporationMessages from 'modules/corporations/messages';
import menuItemMessages from 'common/messages/menuItems';

export const HOME_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnHome,
  path: Routes.HOME,
  label: commonMessages.homeTitle,
};

export const NEW_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnNew,
  label: commonMessages.newTitle,
};

export const EDIT_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnEdit,
  label: commonMessages.editTitle,
};

export const VIEW_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnView,
  label: commonMessages.viewTitle,
};

export const MY_PROFILE_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnMyProfile,
  path: Routes.MY_PROFILE,
  label: commonMessages.myProfile,
};

export const MY_PAYROLL_REPORT_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnMyProfilePayrollReport,
  path: Routes.MY_PAYROLL_REPORT,
  label: commonMessages.myPayrollReport,
};

export const FRONT_DESK_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnFrontDesk,
  path: Routes.FRONT_DESK,
  label: commonMessages.frontDesk,
};

export const POS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPos,
  path: Routes.POS,
  label: commonMessages.pos,
};

export const KID_ZONE_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnKidZone,
  path: Routes.KID_ZONE,
  label: commonMessages.kidZone,
};

export const KID_ZONE_HISTORY_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnKidZoneHistory,
  path: Routes.KID_ZONE_HISTORY,
  label: commonMessages.kidZoneHistory,
};

export const BOOKING_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnBooking,
  path: Routes.BOOKING,
  label: bookingMessages.booking,
};

export const BOOKING_CALENDAR_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnBookingCalendar,
  path: Routes.BOOKING_CALENDAR,
  label: bookingMessages.calendar,
};

export const BOOKING_RESOURCES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnBookingResources,
  path: Routes.BOOKING_RESOURCES,
  label: bookingMessages.resources,
};

export const CRM_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCrm,
  path: Routes.CRM,
  label: commonMessages.crm,
};

export const CRM_TASKS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCrmTasks,
  path: Routes.CRM_TASKS,
  label: crmMessages.tasks,
};

export const CRM_LEADS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCrmLeads,
  path: Routes.CRM_LEADS,
  label: crmMessages.leads,
};

export const CRM_SCRIPTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCrmScripts,
  path: Routes.CRM_SCRIPTS,
  label: crmMessages.scripts,
};

export const CRM_CAMPAIGNS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCrmCampaigns,
  path: Routes.CRM_CAMPAIGNS,
  label: crmMessages.campaigns,
};

export const CRM_SMS_TEMPLATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCrmSmsTemplates,
  path: Routes.CRM_SMS_TEMPLATES,
  label: crmMessages.smsTemplates,
};

export const CRM_EMAIL_TEMPLATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCrmEmailTemplates,
  path: Routes.CRM_EMAIL_TEMPLATES,
  label: crmMessages.emailTemplates,
};

export const PT_CRM_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPTCrm,
  path: Routes.PT_CRM,
  label: commonMessages.ptcrm,
};

export const PT_CRM_TASKS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPTCrmTasks,
  path: Routes.PT_CRM_TASKS,
  label: ptMessages.ptTasks,
};

export const PT_CRM_LEADS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPTCrmLeads,
  path: Routes.PT_CRM_LEADS,
  label: ptMessages.ptLeads,
};

export const PT_CRM_SCRIPTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPTCrmScripts,
  path: Routes.PT_CRM_SCRIPTS,
  label: ptMessages.ptScripts,
};

export const PT_CRM_CAMPAIGNS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPTCrmCampaigns,
  path: Routes.PT_CRM_CAMPAIGNS,
  label: ptMessages.ptCampaigns,
};

export const PT_CRM_SMS_TEMPLATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPTCrmSmsTemplates,
  path: Routes.PT_CRM_SMS_TEMPLATES,
  label: ptMessages.ptSmsTemplates,
};

export const PT_CRM_EMAIL_TEMPLATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPTCrmEmailTemplates,
  path: Routes.PT_CRM_EMAIL_TEMPLATES,
  label: ptMessages.ptEmailTemplates,
};

export const MEMBERS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnMembers,
  path: Routes.MEMBERS,
  label: commonMessages.members,
};

export const EMPLOYEES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnEmployees,
  path: Routes.EMPLOYEES,
  label: commonMessages.employees,
};

export const TIMECLOCK_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnTimeclock,
  path: Routes.TIMECLOCK,
  label: commonMessages.timeclock,
};

export const TIMECLOCK_LOG_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnTimeclockLog,
  path: Routes.TIMECLOCK_LOG,
  label: commonMessages.timeclockLog,
};

export const TIMECLOCK_PAYROLL_REPORTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnTimeclockPayrollReports,
  path: Routes.TIMECLOCK_PAYROLL_REPORT,
  label: timeclockMessages.payrollReportLabel,
};

export const DAY_SHEET_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDaySheet,
  path: Routes.DAY_SHEET,
  label: commonMessages.daySheet,
};

export const DAY_SHEETS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDaySheets,
  path: Routes.DAY_SHEETS,
  label: daySheetMessages.daySheets,
};

export const DAY_SHEET_COMMISSION_RULES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDaySheetCommissionRules,
  path: Routes.COMMISSION_RULES,
  label: daySheetMessages.commissionRules,
};

export const REPORTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReports,
  path: Routes.REPORTS,
  label: commonMessages.reports,
};

export const REPORT_OVERVIEW_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportOverview,
  path: Routes.REPORT_OVERVIEW,
  label: reportMessages.overview,
};

export const REPORT_EXTERNAL_COLLECTIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportExternalCollections,
  path: Routes.REPORT_EXTERNAL_COLLECTIONS,
  label: reportMessages.externalCollections,
};

export const REPORT_SALES_POS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportSalesPos,
  path: Routes.REPORT_SALES_POS,
  label: reportMessages.salesPosReport,
};

export const REPORT_INVOICE_HISTORY_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportInvoiceHistory,
  path: Routes.REPORT_INVOICE_HISTORY,
  label: reportMessages.invoiceHistoryReport,
};

export const REPORT_Z_OUT_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportZOut,
  path: Routes.REPORT_Z_OUT,
  label: reportMessages.zOut,
};

export const REPORT_SALES_OVER_TIME_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportSalesOverTime,
  path: Routes.REPORT_SALES_OVER_TIME,
  label: reportMessages.salesOverTimeReport,
};

export const REPORT_REGISTER_STATUS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportRegisterStatus,
  path: Routes.REPORT_REGISTER_STATUS,
  label: reportMessages.registerStatusReport,
};

export const REPORT_REDEMPTIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportRedemptions,
  path: Routes.REPORT_REDEMPTIONS,
  label: reportMessages.sessionRedemptionReport,
};

export const REPORT_CRM_DASHBOARD_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportCrmDashboard,
  path: Routes.REPORT_CRM_DASHBOARD,
  label: reportMessages.dashboard,
};

export const REPORT_CAMPAIGNS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportCampaigns,
  path: Routes.REPORT_CAMPAIGNS,
  label: reportMessages.campaignReport,
};

export const REPORT_APPOINTMENTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportAppointments,
  path: Routes.REPORT_APPOINTMENTS,
  label: reportMessages.appointmentsReport,
};

export const REPORT_CHECK_IN_HISTORY_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportCheckInHistory,
  path: Routes.REPORT_CHECK_IN_HISTORY,
  label: reportMessages.checkInHistory,
};

export const REPORT_KID_ZONE_CHECK_IN_HISTORY_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportKidZoneCheckInHistory,
  path: Routes.REPORT_KID_ZONE_CHECK_IN_HISTORY,
  label: reportMessages.kidZoneCheckInHistory,
};

export const REPORT_SCHEDULED_BILLINGS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportScheduledBillings,
  path: Routes.REPORT_SCHEDULED_BILLINGS,
  label: reportMessages.scheduledBillings,
};

export const REPORT_PAYMENT_TRANSACTIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportPaymentTransactions,
  path: Routes.REPORT_PAYMENT_TRANSACTIONS,
  label: reportMessages.paymentTransactionsReport,
};

export const REPORT_CHARGE_PAYMENT_ANALYSIS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportChargePaymentAnalysis,
  path: Routes.REPORT_CHARGE_PAYMENT_ANALYSIS,
  label: reportMessages.chargePaymentAnalysis,
};

export const REPORT_FINANCIAL_SUMMARY_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportFinancialSummary,
  path: Routes.REPORT_FINANCIAL_SUMMARY,
  label: reportMessages.financialSummary,
};

export const REPORT_DEPOSIT_STATEMENT_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnReportDepositStatement,
  path: Routes.REPORT_DEPOSIT_STATEMENT,
  label: reportMessages.depositStatement,
};

export const SERVICES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnServicesRoot,
  path: Routes.SERVICES_ROOT,
  label: commonMessages.services,
};

export const SERVICE_SERVICES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnServices,
  path: Routes.SERVICES,
  label: serviceMessages.services,
};

export const SERVICE_FEES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnServiceFees,
  path: Routes.FEES,
  label: serviceMessages.feeDictionary,
};

export const SERVICE_PACKAGES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnServicePackages,
  path: Routes.SERVICE_PACKAGES,
  label: serviceMessages.servicePackages,
};

export const SERVICE_CONTRACT_DOC_TEMPLATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnServiceContractDocTemplates,
  path: Routes.CONTRACT_DOC_TEMPLATES,
  label: serviceMessages.contractTemplates,
};

export const SERVICE_WAIVER_DOC_TEMPLATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnServiceWaiverDocTemplates,
  path: Routes.WAIVER_DOC_TEMPLATES,
  label: serviceMessages.waiverTemplates,
};

export const POS_CONTENT_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContent,
  path: Routes.POS_CONTENT,
  label: commonMessages.posContent,
};

export const POS_CONTENT_RECEIPT_TEMPLATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentReceiptTemplates,
  path: Routes.RECEIPTS,
  label: posSettingsMessages.recieptTemplates,
};

export const POS_CONTENT_TAX_RATES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentTaxRates,
  path: Routes.TAX_RATES,
  label: posSettingsMessages.taxRates,
};

export const POS_CONTENT_REVENUE_CODES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentRevenueCodes,
  path: Routes.REVENUE_CODES,
  label: posSettingsMessages.revenueCodes,
};

export const POS_CONTENT_VENDORS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentVendors,
  path: Routes.VENDORS,
  label: posSettingsMessages.vendors,
};

export const POS_CONTENT_INVENTORY_ITEMS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentInventoryItems,
  path: Routes.INVENTORY_ITEMS,
  label: posSettingsMessages.inventory,
};

export const POS_CONTENT_REGISTERS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentRegisters,
  path: Routes.REGISTERS,
  label: posSettingsMessages.registers,
};

export const POS_CONTENT_DEFAULT_PAYMENT_METHODS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentDefaultPaymentMethods,
  path: Routes.DEFAULT_PAYMENT_METHODS,
  label: posSettingsMessages.defaultPaymentMethods,
};

export const POS_CONTENT_CUSTOM_PAYMENT_METHODS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPosContentCustomPaymentMethods,
  path: Routes.CUSTOM_PAYMENT_METHODS,
  label: posSettingsMessages.customPaymentMethods,
};

export const PERMISSIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPermissions,
  path: Routes.PERMISSIONS,
  label: commonMessages.permissions,
};

export const PERMISSION_ROLES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPermissionRoles,
  path: Routes.ROLES,
  label: permissionMessages.roles,
};

export const PERMISSION_POLICIES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPermissionPolicies,
  path: Routes.POLICIES,
  label: permissionMessages.policies,
};

export const DICTIONARY_CAME_FROM_INDICATION_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryCameFromIndication,
  path: Routes.DICTIONARY_CAME_FROM_INDICATION,
  label: dictionaryMessages.cameFromIndication,
};

export const DICTIONARY_ADDITIONAL_GUEST_FIELDS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryAdditionalGuestFields,
  path: Routes.DICTIONARY_ADDITIONAL_GUEST_FIELDS,
  label: dictionaryMessages.additionalGuestFields,
};

export const DICTIONARY_ALERT_SOUND_UPLOAD_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryAlertSoundUpload,
  path: Routes.DICTIONARY_ALERT_SOUND_UPLOAD,
  label: dictionaryMessages.alertSoundUpload,
};

export const DICTIONARY_NOTE_CODE_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryNoteCodes,
  path: Routes.DICTIONARY_NOTE_CODE,
  label: dictionaryMessages.noteCode,
};

export const DICTIONARY_FALLTHROUGH_REASON_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryFallthroughReason,
  path: Routes.DICTIONARY_FALLTHROUGH_REASON,
  label: dictionaryMessages.fallthroughReason,
};

export const DICTIONARY_DEPARTMENTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryDepartments,
  path: Routes.DICTIONARY_DEPARTMENTS,
  label: dictionaryMessages.departments,
};

export const DICTIONARY_CLUB_GROUPS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryClubGroups,
  path: Routes.DICTIONARY_CLUB_GROUPS,
  label: dictionaryMessages.clubGroups,
};

export const DICTIONARY_INSURANCE_COMPANIES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryInsuranceCompanies,
  path: Routes.DICTIONARY_INSURANCE_COMPANIES,
  label: dictionaryMessages.insuranceCompanies,
};

export const DICTIONARY_ACCESS_HOURS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryAccessHours,
  path: Routes.DICTIONARY_ACCESS_HOURS,
  label: dictionaryMessages.accessHours,
};

export const DICTIONARY_EVENT_TAGS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryEventTags,
  path: Routes.DICTIONARY_EVENT_TAGS,
  label: dictionaryMessages.eventsTags,
};

export const DICTIONARY_RESOURCE_TAGS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryResourceTags,
  path: Routes.DICTIONARY_RESOURCE_TAGS,
  label: dictionaryMessages.resourcesTags,
};

export const DICTIONARY_NOTIFICATIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryNotifications,
  path: Routes.DICTIONARY_NOTIFICATIONS,
  label: dictionaryMessages.notifications,
};

export const DICTIONARY_HELP_INFORMATION_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryHelpInformation,
  path: Routes.DICTIONARY_HELP_INFORMATION,
  label: dictionaryMessages.helpInformation,
};

export const DICTIONARY_END_REASON_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDictionaryEndReason,
  path: Routes.DICTIONARY_END_REASON,
  label: dictionaryMessages.endReason,
};

export const CLUBS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnClubs,
  path: Routes.CLUBS,
  label: commonMessages.clubsLabel,
};

export const CLUB_SETTINGS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnClubSettings,
  path: Routes.CLUB_SETTINGS,
  label: clubSettingsMessages.clubSettingsTitle,
};

export const CORPORATIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCorporations,
  path: Routes.CORPORATIONS,
  label: corporationMessages.corporationsTitle,
};

export const CORPORATE_SETTINGS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCorporateSettings,
  path: Routes.CORPORATE_SETTINGS,
  label: commonMessages.corporateSettings,
};

export const COMMUNICATION_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCommunication,
  path: Routes.COMMUNICATION,
  label: commonMessages.communication,
};

export const COMMUNICATION_BANNERS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCommunicationBanners,
  path: Routes.COMMUNICATION_BANNERS,
  label: communicationMessages.bannerADSForClubLife,
};

export const COMMUNICATION_NOTIFICATIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnCommunicationNotifications,
  path: Routes.COMMUNICATION_NOTIFICATIONS,
  label: communicationMessages.appPushNotifications,
};

export const PEAK_EMPLOYEES_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPeakEmployees,
  path: Routes.PEAK_EMPLOYEES,
  label: commonMessages.employees,
};

export const PEAK_SETTINGS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPeakSettings,
  path: Routes.PEAK_SETTINGS,
  label: menuItemMessages.settings,
};

export const PEAK_REMITTANCE_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPeakRemittance,
  path: Routes.PEAK_REMITTANCE,
  label: remittanceMessages.remittance,
};

export const PEAK_REMITTANCE_CALCULATE_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPeakRemittanceCalculate,
  path: Routes.PEAK_REMITTANCE_CALCULATE,
  label: remittanceMessages.calculateRemittance,
};

export const CLIENT_ADJUSTMENTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnClientAdjustments,
  path: Routes.CLIENT_ADJUSTMENTS,
  label: commonMessages.clientAdjustments,
};

export const CLIENT_ADJUSTMENTS_LIST_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnClientAdjustmentsList,
  path: Routes.CLIENT_ADJUSTMENTS_LIST,
  label: commonMessages.clientAdjustmentsList,
};

export const RECURRING_CLIENT_ADJUSTMENTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnRecurringClientAdjustments,
  path: Routes.RECURRING_CLIENT_ADJUSTMENTS,
  label: commonMessages.recurringClientAdjustments,
};

export const PEAK_CLIENT_ADJUSTMENTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnClientAdjustments,
  path: Routes.PEAK_CLIENT_ADJUSTMENTS,
  label: commonMessages.clientAdjustments,
};

export const PEAK_CLIENT_ADJUSTMENTS_LIST_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnClientAdjustments,
  path: Routes.PEAK_CLIENT_ADJUSTMENTS_LIST,
  label: commonMessages.clientAdjustmentsList,
};

export const PEAK_RECURRING_CLIENT_ADJUSTMENTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnRecurringClientAdjustments,
  path: Routes.PEAK_RECURRING_CLIENT_ADJUSTMENTS,
  label: commonMessages.recurringClientAdjustments,
};

export const DICTIONARY_ADJUSTMENT_CATEGORY_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnAdjustmentCategory,
  path: Routes.DICTIONARY_ADJUSTMENT_CATEGORY,
  label: dictionaryMessages.adjustmentCategory,
};

export const RECONCILIATION_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnDepositReconciliation,
  path: Routes.DEPOSIT_RECONCILIATION,
  label: commonMessages.depositReconciliation,
};

export const PEAK_REPORTS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPeakReports,
  path: Routes.PEAK_REPORTS,
  label: commonMessages.reports,
};

export const PEAK_REPORT_PAYMENT_TRANSACTIONS_BREADCRUMB: IBreadcrumb = {
  id: BreadcrumbId.BcBtnPeakReportPaymentTransactions,
  path: Routes.PEAK_REPORT_PAYMENT_TRANSACTIONS,
  label: reportMessages.paymentTransactionsReport,
};
